import { Flex, Input, InputProps, useColorMode } from '@chakra-ui/react';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMAT } from '~/common/utils/formatter';

interface DateRangeInputProps {
  startDate?: Date | null;
  endDate?: Date | null;
  onStartChange: (date: Date | null) => void;
  onEndChange: (date: Date | null) => void;
  inputProps?: InputProps;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
}

export const DateRangeInput = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  inputProps,
  placeholder = 'Select a date',
  minDate,
  maxDate,
}: DateRangeInputProps) => {
  const { colorMode } = useColorMode();

  const selectedStartDate = (startDate && dayjs(startDate).toDate()) || null;
  const selectedEndDate = (endDate && dayjs(endDate).toDate()) || null;

  const startValue = startDate
    ? dayjs(startDate).format(DEFAULT_DATE_FORMAT)
    : undefined;
  const endValue = endDate
    ? dayjs(endDate).format(DEFAULT_DATE_FORMAT)
    : undefined;

  // Calculate dynamic min/max dates based on selections
  const startDateMaxDate = selectedEndDate ? selectedEndDate : maxDate;
  const endDateMinDate = selectedStartDate ? selectedStartDate : minDate;

  return (
    <Flex alignItems="center" gap={2}>
      <Flex>
        <DatePicker
          customInput={<Input {...inputProps} />}
          maxDate={startDateMaxDate}
          minDate={minDate}
          placeholderText={placeholder}
          popperClassName={colorMode === 'dark' ? 'dark' : undefined}
          selected={selectedStartDate}
          value={startValue}
          withPortal={false}
          onChange={onStartChange}
        />
      </Flex>
      -
      <Flex>
        <DatePicker
          customInput={<Input {...inputProps} />}
          maxDate={maxDate}
          minDate={endDateMinDate}
          placeholderText={placeholder}
          popperClassName={colorMode === 'dark' ? 'dark' : undefined}
          selected={selectedEndDate}
          value={endValue}
          withPortal={false}
          onChange={onEndChange}
        />
      </Flex>
    </Flex>
  );
};
